import { render, staticRenderFns } from "./createPDF.dialog.vue?vue&type=template&id=36613b73&scoped=true"
import script from "./createPDF.dialog.vue?vue&type=script&lang=js"
export * from "./createPDF.dialog.vue?vue&type=script&lang=js"
import style0 from "./createPDF.dialog.vue?vue&type=style&index=0&id=36613b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36613b73",
  null
  
)

export default component.exports